<template>
    <div class="p-2" style="width:250px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ initialMaterialType }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
        <vs-row class="mt-2">
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.Timesheet.MaterialType')}}</form-label>
            <v-select
              label="name"
              :options="materialTypes"
              :reduce="type => type.id"
              v-model="materialType"
              @input="setType"
              class="w-full"
              name="materialType"
            />
          </vs-col>
        </vs-row>
        <vs-row v-if="isMaterialSubTypeEnabled">
          <vs-col class="mb-1" vs-w="12">
            <form-label>{{$t('GradeControl.MaterialSubType.ModelName')}}</form-label>
             <v-select
                label="name"
                :options="materialSubTypes"
                v-model="materialSubTypeId"
                :reduce="materialSubType => materialSubType.materialSubTypeId"
                class="w-full"
              />
          </vs-col>
        </vs-row>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import MaterialTypeEnum from "../MaterialTypeEnum.js";
import { FormLabel } from "../../../shared/components";

export default {
  name: 'MaterialTypeCellEditor',
  data() {
    return {
      materialType: MaterialTypeEnum.Ore,
      materialSubTypeId: null,
      materialTypes: MaterialTypeEnum.definition
    }
  },
  computed: {
    isMaterialSubTypeEnabled() {
      return this.$store.state.gradeControl.materialSubTypes.length > 0;
    },
    materialSubTypes() {
      return this.$store.state.gradeControl.materialSubTypes.filter(l => l.materialType === this.materialType);
    },
    initialMaterialType() {
      if (this.params.value.materialType === null) {
        return ""
      }
      else if (this.params.value.materialSubTypeId === null) {
        return this.$t("Material." + this.params.value.materialType)
      }
      else {
        const subType = this.$store.state.gradeControl.materialSubTypes.find(m => m.materialSubTypeId === this.params.value.materialSubTypeId);
        return this.$t("Material." + this.params.value.materialType) + "-" +  subType.name;
      }
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.materialType = this.params.value.materialType;
    this.materialSubTypeId = this.params.value.materialSubTypeId;
  },
  methods: {
    getValue() {
      const materialType = this.materialType;
      const materialSubTypeId = this.materialSubTypeId
      return {
        materialType,
        materialSubTypeId
      };
    },
    isPopup() {
      return true;
    },
    setType(type) {
      this.materialType = type;
      this.materialSubTypeId = null;
    }
  }
}
</script>
